import { render, staticRenderFns } from "./PddCategoryTabs.vue?vue&type=template&id=66dd4df8&scoped=true&"
import script from "./PddCategoryTabs.vue?vue&type=script&lang=js&"
export * from "./PddCategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./PddCategoryTabs.vue?vue&type=style&index=0&id=66dd4df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd4df8",
  null
  
)

export default component.exports